/**
 * Provider-credential query hook (Phase 2, §7.5).
 *
 * GET /api/provider-credentials returns the current user's single EB app
 * credential or `null` when none is stored. The RSA private key is NEVER part of
 * the response — only `has_private_key` + the non-secret `key_fingerprint`.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '../api.ts';
import { qk } from '../queryKeys.ts';
import type { ProviderCredentialOut } from '../types.ts';

/** The stored EB credential, or `null` when the wizard's step 1 is unfinished. */
export function useProviderCredential(): UseQueryResult<ProviderCredentialOut | null> {
  return useQuery({
    queryKey: qk.providerCredential,
    queryFn: () => api.get<ProviderCredentialOut | null>('/api/provider-credentials'),
    staleTime: 5 * 60 * 1000,
  });
}
